import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { StepStatus } from "../types";

const mapStatusToBadgeVariant = (status: StepStatus) => {
  switch (status) {
    case StepStatus.pending:
      return BadgeVariant.WARNING;
    case StepStatus.verified:
    case StepStatus.finished:
    case StepStatus.approved:
      return BadgeVariant.SUCCESS;
    case StepStatus.failed:
    case StepStatus.rejected:
      return BadgeVariant.ERROR;
    default:
      return BadgeVariant.BASE;
  }
};

export const Status = ({ status }: { status: string }) => {
  return (
    <div>
      <Badge
        variant={mapStatusToBadgeVariant(StepStatus[status])}
        size={BadgeSize.SM}
      >
        {StepStatus[status] || status || ""}
      </Badge>
    </div>
  );
};
